import { useQuery } from "@tanstack/react-query";
import { QR_REDIRECT_URL } from "../../../../../../enums/QueryKeys";
import { fetchQrRedirect } from "../../../../../../enums/queryFunction/Fetch";

export function useGetQrCodeRedirectUrl(qrCodeId) {
  const { data, isLoading, error } = useQuery({
    queryKey: [QR_REDIRECT_URL,qrCodeId],
    queryFn: () => fetchQrRedirect(qrCodeId),
    staleTime: Infinity,
  });

  return { data, isLoading, error };
}